import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PromotionSection.css';
import * as promotionCss from '../../managePromotion/ManagePromotion.css';
import PromotionMessage from '../../promotionMessage/PromotionMessage';
import {getStaticImage} from '../../../globalVariables/GlobalVariables';
import PromotionPopup, {TShow} from '../../prompotionPopup/PromotionPopup';
import {acceptPromotion, promotionAnalytics} from '../../../redux/event/eventActions';
 
const PromotionSection = ({showPromotion, showPromotionPopup, colors} : {showPromotion: TShow; showPromotionPopup: TShow; colors: any;}) => {
    const {t} = useTranslation('promotionMessage');
    const backgroundColor = `linear-gradient(180deg, ${colors[0] || ''} 0%, ${colors[1] || ''} 100%);`;
    const backgroundImage = getStaticImage('app/promotion/oneWeekBeforeEventPromotion.png');
    const PUBLISH_EVENT_PROMOTION = 5;
    
    const handleAccept = () => {
        promotionAnalytics(PUBLISH_EVENT_PROMOTION, 'send_click').then(() => {
            showPromotion.close();
            showPromotionPopup.open();
        });
        acceptPromotion(PUBLISH_EVENT_PROMOTION);
    };

    return (
        <>
            {showPromotion.isOpen && (
                <css.promotionMessage>
                    <PromotionMessage
                        show={showPromotion}
                        secondTitle={t('promotionMessageTitle')}
                        text={t('promotionMessageText')}
                        background={{image: backgroundImage, color: backgroundColor}}
                        button={{onClick: handleAccept, text: t('getHelp'), color: colors[2]}}
                        close={showPromotion.close}
                        firstTitle={''}
                    />    
                </css.promotionMessage>
            )}
            {showPromotionPopup.isOpen && (
                <css.promotionPopup>
                    <PromotionPopup show={showPromotionPopup} color={backgroundColor} image={backgroundImage} button={{onClick: showPromotionPopup.close, text: t('thanks'), disabled: false}}>
                        <promotionCss.title>{t('popupMessageTitle')}</promotionCss.title>
                        <promotionCss.text>{t('popupMessageText')}</promotionCss.text>
                        <promotionCss.contact>{t('contactDetails')}</promotionCss.contact>
                    </PromotionPopup>
                </css.promotionPopup>
            )}
        </>
    );
};

export default PromotionSection;